import React from 'react';

const AboutUsContent = () => {
  return (
    <section className="w-full md:w-[80%] lg:w-[70%] mx-auto px-6 sm:px-10 font-Roboto  text-[clamp(1.1rem,1.4vw,1.6rem)]">
        <div className="mb-8">
        <p className=' mb-4'>At Global Vakya, we get it—knowing tons of words and grammar rules doesn’t mean much if you can’t connect with people on a deeper level. We believe language is all about breaking barriers, meeting people from all walks of life, and truly embracing different cultures. Our goal? Make sure you can speak a new language fluently and confidently in today’s world.</p>
        </div>
        <div className="mb-8">
        <h3 className='  text-clamp-h2 font-semibold font-RobotoSlab mb-4 '>Our Philosophy</h3>
        <p className='mb-4'>We’re all about a flexible, student-centered approach. We offer a full range of language courses that match different levels and learning styles. Whether you’re just starting, looking to boost your career, or already know the language and want to take it further, we’ve got the right program for you. Our courses are fun, interactive, and culture-rich, so you’ll pick up language skills that work in real life, not just in the classroom.</p>
        </div>
        <section className="mb-8">
        <h2 className=" text-clamp-h2 font-semibold font-RobotoSlab  mb-4">Meet Our Founder</h2>
        <p className="mb-4">
        Global Vakya was started by a passionate language teacher who really gets what it takes to help students learn. With over ten years of experience, our founder has taught at universities across the globe, gaining new perspectives and sharpening their skills along the way. With advanced degrees in Spanish and Dutch, they’ve helped countless students—whether for work, travel, or just the joy of learning—feel comfortable and fluent in a new language.

        </p>

      </section>
      <section className="mb-8">
        <h2 className=" text-clamp-h2 font-semibold font-RobotoSlab  mb-4">Why Choose Global Vakya? </h2>
        <ul className="list-disc list-inside space-y-2">
          <li><strong>Customized Learning:</strong> We know every student is different, so we tailor our courses to fit your goals and learning style.
          </li>
          <li><strong>Skilled Trainers:</strong>Our team of dedicated teachers is here because they love what they do and are committed to your success </li>
          <li><strong>Cultural Immersion:</strong>Language and culture go hand in hand. Our courses bring the culture to life, so you’ll understand more than just words. </li>
          <li><strong>Community Feel:</strong> Our environment is all about connecting with others who share your passion for languages.</li>
        </ul>
      </section>
      <section className="mb-8">
        <h2 className=" text-clamp-h2 font-semibold font-RobotoSlab  mb-4">Our Courses</h2>
        <ul className="list-disc list-inside space-y-2">
          <li><strong>Language Courses:</strong>Learn languages like English, Spanish, French, German, Mandarin, and more. </li>
          <li><strong>Business Language Training : </strong>Courses designed to help you speak confidently in the global business world.
          </li>
          <li><strong>Test Prep: </strong>Get ready for exams like TOEFL, IELTS, DELE, and HSK with our focused prep programs. </li>
          <li><strong>Kids and Teens Programs:</strong> Fun, effective courses that give younger learners a strong start in language.</li>
          <li><strong>Conversation Clubs and Cultural Workshops:</strong>           <li><strong>Conversation Clubs and Cultural Workshops:</strong> Get a sense of the culture and how things are done while practicing the language more practically.</li>
          </li>
        </ul>
      </section>

      

     

 
    </section>
  );
};

export default AboutUsContent;
